import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'num_of_female_union_officials_in_the_union_w_the_largest_member'

export const dataPointDefinition = {
  retracedId: 'num_of_female_union_officials_in_the_union_w_the_largest_member',
  name: 'NUMBER of female union officials in the union with the largest membership in the facility',
  description: 'Facility trade union officials are the representatives for their union at the enterprise.',
  meta: {},
  fieldTypeId: 'NUMBER',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'number',
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'wi-foa-8',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 11830,
  sectionId: '2.2.8',
  impactArea: 'Freedom of Association and Collective Bargaining',
  impactAreaId: 'FREEDOM_OF_ASSOCIATION_AND_COLLECTIVE_BARGAINING',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
